import React from 'react';
import { OrderStatus, STATUS_CONFIG } from './types';
interface StatusBadgeProps {
  status: OrderStatus;
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  size = 'md'
}: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  return <span className={`inline-flex items-center gap-1.5 border rounded-full font-medium ${config.bg} ${config.color} ${size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'}`} data-id="element-817">
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} data-id="element-818" />
      {config.label}
    </span>;
}